const formatNumber = (number) => {
  return new Intl.NumberFormat('en-US', { style: 'decimal', maximumSignificantDigits: 7 }).format(
    number
  );
};

export { formatNumber };
